import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms'
import { PersonaFactoryService } from './persona.model'
import { PersonaValueChangeHook } from './persona.value-change.hook'

/**
 * Updates a persona slug based on it's name
 */
export class NameValueChangeHook extends PersonaValueChangeHook {
  /** creates the class */
  constructor(private pf: PersonaFactoryService) {
    super()
  }
  /**
   * Updates a persona slug based on it's current name in case it's a new persona
   * @param personas personas list controls
   * @param persona current persona
   * @param control name control
   * @param value name control value
   */
  valueChanged(personas: UntypedFormArray, persona: UntypedFormGroup, control: AbstractControl, value: string): void {
    // Only apply it to new personas
    if (!persona.value.id) {
      const formSlug = value
        .replace(' ', '')
        .replace(
          /[^a-zA-Z0-9]/g,
          Math.random()
            .toString(36)
            .replace(/[^a-z]+/g, '')
        )
        .slice(0, 3)
        .toLowerCase()

      persona.patchValue({
        slug: formSlug
      })
    }
  }
}
